import { useState, useEffect } from "react";

export const useScreenSize = () => {
  const [ dimension, setDimension ] = useState({
    width: window.innerWidth,
    heigth: window.innerHeight,
  });

  useEffect(()=>{
      window.addEventListener('resize', ()=>{
          setDimension({
            width: window.innerWidth,
            heigth: window.innerHeight,
          })
      })
  },[])

  return dimension ;
};
